import * as React from 'react'
import {
  CallNowSectionButtonWrapper,
  CallNowSectionColumn,
  CallNowSectionContainer, CallNowSectionContent, CallNowSectionNumberColumn,
  CallNowSectionText,
  CallNowSectionWrapper, CallSpan, HoursSpan,
  PhoneNumberWrapper, StyledDiv
} from './CallNowSection.elements'
import {PhoneNumber} from "@components/PhoneNumber";
import {getPhoneNumber} from "@lib/PhoneNumber";
import Analytics from "@lib/Analytics";
import Pixels from '@lib/Pixels'
import {Button} from "@components/Button";

export type CallNowSectionProps = {
  title: string;
  phoneMapping: PhoneMapping;
  hours: string;
  buttonText: string;
  subtitle?: string;
  mobileTextLeft?: boolean;
  buttonFullWidth?: boolean;
}

export const CallNowSection: React.FunctionComponent<CallNowSectionProps> = ({title, phoneMapping, hours, buttonText, subtitle, mobileTextLeft, buttonFullWidth}) => {

  const onClickCall = () => {
    const number = getPhoneNumber(phoneMapping);
    Pixels.callEvent()
    Analytics.log('Click To Call', {
      location: 'header', info: `tel:${ number }`
    });
    window.location.href = `tel:${ number }`;
  }

  return (
    <CallNowSectionContainer>
      <CallNowSectionWrapper>
        <CallNowSectionContent>
          <CallNowSectionColumn>
            <CallNowSectionText mobileTextLeft={mobileTextLeft} dangerouslySetInnerHTML={{ __html: title }}/>
          </CallNowSectionColumn>
          <CallNowSectionNumberColumn mobileTextLeft={mobileTextLeft}>
            <StyledDiv>
              <CallSpan>{subtitle ? subtitle : `Call `}</CallSpan>
              {!subtitle &&
                <PhoneNumberWrapper
                  onClick={onClickCall}
                  aria-label="Click to Call"
                >
                  <PhoneNumber mapping={phoneMapping} format={'pretty'}/>
                </PhoneNumberWrapper>
              }
            </StyledDiv>
            <HoursSpan dangerouslySetInnerHTML={{ __html: hours }}/>
            <CallNowSectionButtonWrapper buttonFullWidth={buttonFullWidth} >
              <Button variant="white" onClick={onClickCall} >{buttonText}</Button>
            </CallNowSectionButtonWrapper>
          </CallNowSectionNumberColumn>
        </CallNowSectionContent>
      </CallNowSectionWrapper>
    </CallNowSectionContainer>
  )
}